var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var SpeechBubble = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "35", height: "28" }, props),
        React.createElement("path", { d: "M23.329 6.819c.12-.031.239-.031.359-.031 3.022 0 5.774.958 7.749 2.535 2.094 1.607 3.351 3.833 3.351 6.306 0 1.947-.778 3.74-2.094 5.193-1.197 1.329-2.842 2.349-4.727 2.967v3.338c0 .216-.09.464-.269.618a.83.83 0 0 1-1.197 0l-3.171-3.276c-2.872-.062-5.505-1.02-7.42-2.504-.957-.742-1.735-1.607-2.334-2.596 2.154-.402 4.248-1.267 6.014-2.627 2.393-1.854 4.039-4.575 4.039-7.727 0-.773-.12-1.515-.299-2.194h0zM11.045 0c2.999 0 5.731.958 7.69 2.504 2.078 1.607 3.326 3.833 3.326 6.337 0 2.473-1.247 4.729-3.326 6.337-1.9 1.484-4.484 2.411-7.334 2.504l-3.147 3.277c-.356.34-.891.34-1.217 0-.148-.185-.238-.402-.238-.618v-3.338c-1.9-.618-3.533-1.669-4.691-2.967C.772 12.581 0 10.788 0 8.84c0-2.504 1.277-4.729 3.326-6.337C5.315.958 8.047 0 11.046 0h-.001z", fill: color })));
};
SpeechBubble.defaultProps = {
    color: '#fff',
};
export default SpeechBubble;
//# sourceMappingURL=SpeechBubble.js.map